import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { ProfileModel } from '../models/profile.model';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';
 
@Injectable({
  providedIn: 'root',
})

export class UserResolverService implements Resolve<ProfileModel> {

  constructor(private dataService: DataService, private auth:AuthenticationService) {
  }
 
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ProfileModel> {
    const currentUser = await this.auth.getUser();
    // console.log('user resolver current user',currentUser);
    return currentUser;
  };
}